import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import SuccessAlertModal from "../../Components/Modals/successAlertModal";
import ConfirmAlertModal from "../../Components/Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import { getAllProject, UpdateProject, DeleteProject } from "../../Services/project-services";
import { checkProjectItem } from "../../Services/item-services";
import { checkProjectWCS } from "../../Services/wcs-services";
import { checkProjectWPS } from "../../Services/wps_groove-services";
import { checkWpqNpcilLinking } from "../../Services/WI-services";
import AddEditProjectMaster from "./AddEditProjectMaster";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";

import GridMaster from "../utility/grid/GridMaster";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import Toaster, { showSuccess as showSuccessToast, showWarning } from "../utility/ui/notifications/Toaster";
import Export_blue from "../../icons/Export_blue.svg";
import ExportIcon from "../../icons/ExportIcon.svg";

const ProjectMaster = forwardRef((props, ref) => {
  let formName = "Project Master";
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setcolumnDefs] = useState([]);
  const [Project, setProject] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [data, setdata] = useState("");
  const [reload, setReload] = useState(false);
  const [excelData1, setExcelData] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const childRef = useRef();

  const tmpcolumnDefs = [
    {
      headerName: "Status",
      field: "wld_status",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "statusRenderer",
      sortable: true,
      sort: 'asc',
    },
    {
      headerName: "Project Number",
      field: "SK",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Equipment Number",
      field: "wld_equipnumber",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Client name",
      field: "wld_clientname",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Critical code",
      field: "wld_criticalcode",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Inspection Agency",
      field: "wld_inspectionagency",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
  ];


  const handleEdit = (row) => {
    setAction("Edit");
    setRowData(row);
    setShowForm(true);
  };

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchProject = async () => {
    const result = await getAllProject();
    setProject(result);
    setFilteredResult(result);
  };
  const fetchColumnDefns = async () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result.push({
      field: "", cellRenderer: actionRenderer, width: 250, suppressMenu: true,
      sortable: false,
    });
    setcolumnDefs(result);
  };

  useEffect(() => {
    fetchProject();
    fetchColumnDefns();
  }, [reload]);

  useImperativeHandle(ref, () => ({
    handleAdd: async () => {

      setAction("Add");
      setShowForm(true);
      setReload(true);
    },
  }));

  const resetForm = () => {
    document.filterForm.reset();
    setFilteredResult(Project);
  };


  const msg = "";
  const history = useNavigate();
  const [show1, setShow1] = useState(false);


  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setProject",
    });
  };

  const handleCloseSuccess = () => setShowSuccess(false);

  const handleClose = () => {
    setShow1(false);
  };

  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text);


  };

  const handleGlobalExport = () => {
    let filename = "ProjectMaster";
    setExcelData(filteredResult);
    handleExport1(excelData1, filename, tmpcolumnDefs);
  };

  const actionRenderer = (params) => {
    return (
      <UnifiedActionRenderer
        actions={['edit', 'delete']}
        selectedData={params}
        handleEditEvent={(params) => handleEdit(params.data)}
        handleDeleteEvent={(params) => {
          setdata(params.data);
          setShow1(true);
          setAction("Delete");
        }}
      />
    );
  };
  const handleDelete = async () => {
    try {
      // Check if project is used in Item Master, WCS, WPS, and WPQ/NPCIL Linking
      const [itemCheckResult, wcsCheckResult, wpsCheckResult, wpqLinkingResult] = await Promise.all([
        checkProjectItem({ PK: "Item", SK: data.SK }).catch(err => ({ status: false, error: err })),
        checkProjectWCS({ PK: "WCS_HEADER", SK: data.SK }).catch(err => ({ status: false, error: err })),
        checkProjectWPS({SK: data.SK }).catch(err => ({ status: false, error: err })),
        checkWpqNpcilLinking({
          PK: data.wld_inspectionagency === "NPCIL" ? "NpcilWpqLinking" : "WPQ_Linking",
          SK: data.SK
        }).catch(err => ({ status: false, error: err }))
      ]);
      
      console.log("Validation results:", { itemCheckResult, wcsCheckResult, wpsCheckResult, wpqLinkingResult });
      
      // Check validation results
      const hasUsage = itemCheckResult?.status || wcsCheckResult?.status || wpsCheckResult?.status || wpqLinkingResult?.status;
      
      let result;
      let operationType;
      if (!hasUsage) {
        // No usage found, safe to delete
        result = DeleteProject({ PK: data.PK, SK: data.SK });
        operationType = "delete";
      } else {
        // Usage found, deactivate instead
        data.wld_status = "Inactive";
        result = UpdateProject(data);
        operationType = "deactivate";
      }
      
      result
        .then((resp) => {
          console.log("API Response:", resp);
          // Handle both direct response and Axios response
          const message = resp.data ? resp.data.message : resp.message;
          if (message === "Success" || message === "Deleted") {
            setShowForm(false);
            showSuccessToast(operationType === "delete" ? `Selected Project has been Deleted successfully` : `Selected Project has been deactivated successfully`);
          } else {
            console.log("Unexpected response message:", message);
            showWarning(`Error!!!, Not able to ${operationType} Project`);
          }
          setReload(!reload);
        })
        .catch((error) => {
          showWarning("Error!!!, Not able to Add or deactivate Data");
        })
        .finally(() => {
          setdata("");
          setShow1(false);
        });
    } catch (error) {
      console.error("Error in handleDelete:", error);
      showWarning("Error!!!, Unable to validate project usage");
      setdata("");
      setShow1(false);
    }
  };

  return (
    <Container fluid>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={msg}
        show={showSuccess}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleDelete}
        formName={formName}
        show={show1}
        handleClose={handleClose}
      />
      <Row className="RowHeight">
        <Col md={2} sm={12} xs={12} className="ListTitle">
          Project list
        </Col>
        <Col>
          <div className="global-search-container">
            <GolbalSearch
              filterFunc={handleGlobalSearch}
              searchplaceholdertext={
                "Search for Project Number,Equipment Number,Client Name,Critical Code,Inspection Agency"
              }
            />
            <img
              className="allexport"
              src={ExportIcon}
              onMouseOver={(e) => (e.currentTarget.src = Export_blue)}
              onMouseOut={(e) => (e.currentTarget.src = ExportIcon)}
              alt="ExportIcon"
              onClick={handleGlobalExport}
            />
          </div>
        </Col>
      </Row>
      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}
        setExcelData={setExcelData}
        ref={childRef}
        paginationPageSize={7}
        pagination={true}
      />
      {showForm && (
        <AddEditProjectMaster
          show={showForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowForm(false)}
          resetForm={resetForm}
          setReload={setReload}
          reload={reload}
          fetchUserMaster={fetchProject}
          allRecs={Project}
          backdrop="static"
        />
      )}
      <Toaster />
    </Container>
  );
});

export default ProjectMaster;